export class MissingSignatureError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, MissingSignatureError.prototype);
  }
}
